function collectAllElementsDeep(root: HTMLElement) {
  const allElements: HTMLElement[] = [];

  const findAllElements = function (nodes: NodeListOf<HTMLElement>) {
    for (let i = 0; i < nodes.length; i++) {
      const el = nodes[i];
      allElements.push(el);
      if (el.shadowRoot) {
        findAllElements(el.shadowRoot.querySelectorAll("*"));
      }
    }
  };
  if (root.shadowRoot) {
    findAllElements(root.shadowRoot.querySelectorAll("*"));
  }
  findAllElements(root.querySelectorAll("*"));
  return allElements;
}

export function querySelectorDeep(selector: string, rootNode = document.body) {
  return collectAllElementsDeep(rootNode).find((element) =>
    element.matches(selector),
  );
}

export function querySelectorAllDeep(
  selector: string,
  rootNode = document.body,
) {
  return collectAllElementsDeep(rootNode).filter((element) =>
    element.matches(selector),
  );
}
